import React, { useId } from 'react';

export function WrkthruMark({ size = 32 }: { size?: number }) {
  // Unique per-instance so the gradient renders correctly when the mark appears
  // more than once on a page (e.g. the Wrkthru header and the sidebar nav item).
  const gradientId = useId();
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <defs>
        <linearGradient id={gradientId} gradientUnits="userSpaceOnUse" x1="3" y1="0" x2="21" y2="0">
          <stop offset="0%" stopColor="#b6a258" />
          <stop offset="55%" stopColor="#bc45d3" />
          <stop offset="100%" stopColor="#e040fb" />
        </linearGradient>
      </defs>
      <rect x="3" y="5" width="18" height="3.2" rx="1.2" fill={`url(#${gradientId})`} />
      <rect x="3" y="11" width="13" height="3.2" rx="1.2" fill="#0077b6" opacity="0.55" />
      <rect x="3" y="17" width="8" height="3.2" rx="1.2" fill="#0077b6" opacity="0.35" />
    </svg>
  );
}
